import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const employmentTypeService = {
  getAll,
  getAllEmpTypes,
  add,
  update,
  deleteEmpTypes,
};

async function getAll(limit, offset, search_term) {
  const configOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/employment/getAll/${limit}/${offset}?search_term=${search_term}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllEmpTypes() {
  const configOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/employment/getAll/`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function add(newGender) {
  const configOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(newGender),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/employment/add`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function update(emp, emp_id) {
  const configOptions = {
    method: "PUT",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(emp),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/employment/update/${emp_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function deleteEmpTypes(id) {
  const configOptions = {
    method: "DELETE",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/employment/delete-employment/${id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

